import {
  FC,
  memo,
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useLocation } from 'react-router';

import { StoredReturnUrl } from './logic/resolveReturnUrl';
import { ReturnUrlContext } from './ReturnUrlContext';

const ReturnUrlProviderComponent: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const [stored, setStored] = useState<StoredReturnUrl>({
    url: location.pathname + location.search,
    owner: undefined,
  });

  const setReturnUrl = useCallback((path: string, owner?: string) => {
    setStored({ url: path, owner });
  }, []);

  const value = useMemo(
    () => ({
      returnUrl: stored.url,
      returnUrlOwner: stored.owner,
      setReturnUrl,
    }),
    [stored, setReturnUrl],
  );

  return (
    <ReturnUrlContext.Provider value={value}>
      {children}
    </ReturnUrlContext.Provider>
  );
};

export const ReturnUrlProvider = memo(ReturnUrlProviderComponent);
